import React, { useEffect, useState } from 'react'
import WebComponentContainer from '../generic/WebComponentContainer'
// import useEventBus from '../generic/useEventBus'

export default ({ vehicleName, trim, vin, currentStep, pages, stepClick, mileage, theme }) => {
  const [pageLoaded, setPageLoaded] = useState(false)
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    setPageLoaded(true)
  }, [])

  useEffect(() => {
    setShowLoader(false)
  }, [])

  return (
    <WebComponentContainer pageLoadingComplete={pageLoaded} withLoader={showLoader} maxWidth="100%" location={'breadcrumb'}>
      <div className={theme ? `${theme}-theme` : ''}>
        <yes-its-perfect-modal />
      </div>
    </WebComponentContainer>
  )
}
